import {combineReducers} from "redux";

import {userData} from "./reducer/userData";
import {inputError} from "./reducer/inputError";
import {loading} from "./reducer/loading";
import {page} from "./reducer/page";
import manualForward from "./reducer/manualForward";
import result from "./reducer/result";
import fieldLabels from "./reducer/fieldLabels";
import app from "./reducer/app";
import dynamicOptions from "./reducer/dynamicOptions";
import {shop} from "./reducer/shop";
import {settings} from "./reducer/settings";

export default combineReducers({
    userData,
    inputError,
    loading,
    page,
    manualForward,
    result,
    fieldLabels,
    app,
    dynamicOptions,
    shop,
    settings

});
